import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Container,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import { enviarmails, logEventos } from "../../../services/services";

import "moment/locale/es"; // Importa el idioma español
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR ARCHIVOS

import moment from "moment";

const EvaluacionesMedicasForm = ({
  isEditMode,
  mostrarAlertaTemporal,
  onClose,
  idCandidato,
  props,
  obtenerEvaluaciones /* No esta pasado*/,
}) => {
  const [data, setData] = useState({
    id: isEditMode ? props.id : undefined,
    id_candidato: idCandidato,
    prestador: isEditMode ? props.prestador : "",
    aprobado_parte_medico: isEditMode ? props.aprobado_parte_medico : null,
    aprobado_parte_rrhh: isEditMode ? props.aprobado_parte_rrhh : null,
    fecha: isEditMode ? moment(props.fecha).format("YYYY-MM-DD") : null,
    uuid: isEditMode ? props.uuid_archivo : uuidv4(),
    user: isEditMode ? props.user : localStorage.getItem("user"),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    logEventos(
      isEditMode ? "Editar evaluacion medica " : "Agregar evaluacion medica",
      "Evaluaciones medicas",
      isEditMode
        ? "Editar una evaluacion medica"
        : "Crear una evaluacion medica",
      localStorage.getItem("user")
    );

    if (
      data.prestador === "" ||
      data.prestador.trim() === "" ||
      data.fecha === null ||
      data.fecha === ""
    ) {
      mostrarAlertaTemporal(
        "Por favor, complete todos los campos obligatorios y verifique que los datos sean correctos.",
        "error"
      );
      return;
    }

    let solicitud = {
      ...data,
    };

    if (isEditMode) {
      const { uuid, ...rest } = data;
      solicitud = { ...rest };
    }

    if (!isEditMode) {
      const { id, ...rest } = data;
      solicitud = { ...rest };
    }

    const url = isEditMode
      ? `${UrlApi}/SP_evaluaciones/${data.id}`
      : `${UrlApi}/SP_evaluaciones`;
    const method = isEditMode ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(solicitud),
      });

      if (response.ok) {
        mostrarAlertaTemporal(
          isEditMode
            ? "Evaluacion medica actualizada correctamente"
            : "Evaluacion medica creada con éxito",
          "success"
        );
        obtenerEvaluaciones();
        onClose();
      } else {
        const error = await response.json();
        mostrarAlertaTemporal(`Error: ${error.message}`, "error");
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      mostrarAlertaTemporal("Hubo un problema con la solicitud.", "error");
    }
  };
  return (
    <Dialog open={true} onClose={onClose} maxWidth="lg" fullWidth>
      <Box sx={{ backgroundColor: "#1F618D", marginBottom: 4 }}>
        <DialogTitle>
          <Typography variant="h6" align="center" color="#fff">
            {isEditMode ? "Editar evaluacion" : "Nueva evaluacion"}
          </Typography>
        </DialogTitle>
      </Box>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Prestador"
              name="prestador"
              value={data.prestador}
              onChange={handleChange}
              required
              inputProps={{ maxLength: 70 }}
            />
            <Typography variant="body2" color="textSecondary">
              {data.prestador.length} / 70 caracteres
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Fecha de la evaluacion"
              name="fecha"
              value={moment(data.fecha).format("YYYY-MM-DD")}
              onChange={handleChange}
              required
              type="date"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button onClick={onClose} color="error">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} color="primary">
              {isEditMode ? "Guardar" : "Agregar"}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
};

export default EvaluacionesMedicasForm;
